import React from 'react';

interface UnerroredState {
  hasError: false;
}

interface ErroredState {
  hasError: true;
  message: string;
}

// interface State {
//   hasError: boolean;
//   message?: string;
// }

type State = UnerroredState | ErroredState;

export class ErrorBoundary extends React.Component {
  readonly state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(error: Error) {
    console.error(error);
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      message: error.message,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ margin: '16px' }}>
          <h1>Something went wrong.</h1>
          <p>{this.state.message}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
